import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { EmployeesModel } from 'src/app/model/employees.model';

@Injectable({
  providedIn: 'root'
})
export class EmployeesService {
  private url:string;

  ////////////////
  constructor(
    private http:HttpClient
  ) {
    this.url=environment.services_url;
  }

  //
  getAll=()=> {
    return this.http.get(`${this.url}/employee/list`)
      .pipe(
        map((resp:any)=> resp)
      );
  }
  save=(employee:EmployeesModel, userName:string)=> {
    return this.http.post(`${this.url}/employee/saveEmployee/${userName}`, employee)
      .pipe(
        map((resp:any)=> resp)
      );
  }
  upload=(userName: string, file: File, replace: boolean)=> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('userName', userName);
    formData.append('table', 'employee');
    formData.append('replace', String(replace));
    formData.append('userId', localStorage.getItem('com_token'));
    return this.http.post(`${this.url}/upload/save`, formData)
      .pipe(
        map((resp:any)=> resp)
      );
  }

  downloadLayout = () => this.http.get(`${this.url}/employee/DownloadLayout`, { responseType: 'blob' });
}
